import type { ProductListItem } from "@/lib/api-client";
import { ProductCard } from "./ProductCard";

export interface RelatedProductsRowProps {
  title: string;
  items: ProductListItem[];
}

/**
 * Porté à l'identique depuis apps/web/components/product/RelatedProductsRow.tsx
 * (aucune dépendance Next.js dans l'original).
 */
export function RelatedProductsRow({ title, items }: RelatedProductsRowProps) {
  if (items.length === 0) return null;

  return (
    <section className="border-t border-line py-8">
      <h2 className="mb-4 font-display text-xl font-semibold text-navy">{title}</h2>
      <div className="flex gap-4 overflow-x-auto pb-2">
        {items.map((item) => (
          <div key={item.id} className="w-[46%] shrink-0 sm:w-[32%] md:w-[24%] lg:w-[19%]">
            <ProductCard product={item} />
          </div>
        ))}
      </div>
    </section>
  );
}
